import { Injectable } from '@angular/core';

import { FieldFactory } from "./field-factory.interface";
import { fieldFactoriesList } from '@core/custom-forms/factories/field-factory-index';

/**
 * This class will maintain a registry of field factories 
 * for different types of fields.
 * // <diego@twonas.com> 9/8/2024 
 * see https://v16.angular.io/guide/dependency-injection-providers
 */
@Injectable()
export class FieldFactoryLocator {
    private registry: FieldFactory[] = [];
    constructor(private factories: FieldFactory[]) {
        this.factories.forEach((factory: FieldFactory) => {
            this.registerFactory(factory);
        });
        // console.log(" ### thisss registry ", this.registry)
    }

    private registerFactory(factory: FieldFactory): void {
        this.registry.push(factory);
        // console.log(`Field factory for type ${factory.type} is registered.`);
    }

    public get = (type: string): FieldFactory => {
        // const factory = this.registry[type];
        const factory = this.registry.find((f:FieldFactory) => type == f.type );
        if (!factory) {
            throw new Error(`Field factory for type ${type} is not registered.`);
        }
        return factory;
    };

    // method to get all factories to get all available
    public findAllFactories(): FieldFactory[] {
        return this.registry;
    }

    /**
     * 
     * @returns a list of not deprecated field factories
     */
    public findAvailableFactories() : FieldFactory[] {
        return this.registry.filter((f:FieldFactory) => !f.deprecated);
    }



}

export const fieldFactoryLocatorProvider = () =>
    new FieldFactoryLocator(fieldFactoriesList.map((f) => new f()));

